<script setup lang="ts">

import Thumbnail from '@/components/Common/ImagethumbnailDisplay.vue';
import { computed } from 'vue';
import i18n from '@/lang/i18n';
import { firstFile } from '@/services/functions';

const props = defineProps<{
  modelValue: File | File[] | null | undefined,
  form: Record<string, any>,
  modelId: number,
  errors: Record<string, any>,
  isInstallationOffice: boolean | undefined,
}>();


const emit = defineEmits(['update:modelValue', 'removeImage']);
  const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});
</script>

<template>
  <v-file-input
    :label="i18n.global.t('pages.vehicles.form.vehicleVerifyImage')"
    v-model="modelValue"
    truncate-length="15"
    :error-messages="errors.img"
    :disabled="isInstallationOffice"
  />
  <div
    v-if="
      (form.vehicle_verify_image && form.vehicle_verify_image.length) ||
      firstFile(modelValue)
    "
    class="d-flex align-items-end"
  >
    <Thumbnail
      :image="form.vehicle_verify_image"
      :newImage="modelValue"
      modelName="vehicles"
      :modelId="props.modelId"
    />
    <v-btn
      class="exec-btn bg-danger text-white delete-btn"
      @click="() => emit('removeImage')"
    >
      {{ i18n.global.t('pages.vehicles.form.removeImage') }}
    </v-btn>
  </div>
</template>
<style scoped>
.delete-btn {
  margin: 1vw;
}
</style>
